import React from 'react';
import {
	Box,
	Container,
	Grid,
	makeStyles,
	Avatar,
	Chip,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Slider,
	withStyles,
	FormControlLabel,
	Checkbox,
	Hidden,
} from '@material-ui/core';
import musafirbazarlogo from '../../assets/images/musafirbazarlogo.png';
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import LocalPhoneIcon from '@material-ui/icons/LocalPhone';
import { useDispatch, useSelector } from 'react-redux';
import logo from '../../assets/images/musafirbazarlogo.png';
import account from '../../assets/images/my.png';
// import account from '../../assets/images/account.PNG';
import call from '../../assets/images/call.PNG';
import { toggleDrawerModal, toggleLoginModal } from '../../reducers/UiReducer';
import { useHistory } from 'react-router-dom';
import Login from './Login';
const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiChip-sizeSmall': {
			height: 36,
		},
	},
	accodin: {
		'& .MuiAccordionSummary-content': {
			justifyContent: 'space-between',
		},
	},
}));

const Header = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();
	const { agentlogin } = useSelector((state) => state.user);
	return (
		<>
			<Box display='flex' justifyContent='space-between' alignItems='center'>
				<Box display='flex' alignItems='center'>
					<Avatar
						style={{
							backgroundColor: 'rgba(0,0,0,.3)',
							cursor: 'pointer',
						}}>
						<FormatAlignLeftIcon
							onClick={() => dispatch(toggleDrawerModal(true))}
						/>
					</Avatar>
					<Box
						style={{ marginLeft: 30, cursor: 'pointer' }}
						onClick={() => history.push('/')}>
						<img src={logo} height='50px'></img>
					</Box>
				</Box>
				<Hidden only={['xs', 'sm']}>
					<Box display='flex' mr={'60px'}>
						{agentlogin &&
						agentlogin.result &&
						agentlogin.result.result &&
						agentlogin.result.result.access_token ? (
							<Chip
								onClick={() => history.push('/dashboard')}
								variant='outlined'
								size='small'
								style={{
									color: 'white',
									backgroundColor: 'rgba(0,0,0,.4)',
									borderRadius: 25,
									padding: '15px 7px 15px',
									fontSize: 14,
									cursor: 'pointer',
								}}
								// avatar={<i class='fa fa-user' aria-hidden='true'></i>}
								label='MyAccount'
								// onClick={handleClick}
							/>
						) : (
							<>
								{' '}
								<Chip
									variant='outlined'
									size='small'
									style={{
										color: 'white',
										backgroundColor: 'rgba(0,0,0,.4)',
										borderRadius: 25,
										padding: '15px 7px 15px',
										fontSize: 14,
										cursor: 'pointer',
										marginLeft: 5,
									}}
									// avatar={<Avatar src={account}></Avatar>}
									label='Traveller'
									// onClick={handleClick}
								/>
								{/* <Chip
							variant='outlined'
							size='small'
							style={{
								color: 'white',
								backgroundColor: 'rgba(0,0,0,.4)',
								borderRadius: 25,
								padding: '15px 7px 15px',
								fontSize: 14,
								cursor: 'pointer',
								marginLeft: 5,
							}}
							avatar={<Avatar src={account}></Avatar>}
							label='Corporate'
							// onClick={handleClick}
						/> */}
								<Chip
									onClick={() => dispatch(toggleLoginModal(true))}
									variant='outlined'
									size='small'
									style={{
										color: 'white',
										backgroundColor: 'rgba(0,0,0,.4)',
										borderRadius: 25,
										padding: '15px 7px 15px',
										fontSize: 14,
										cursor: 'pointer',
										marginLeft: 5,
									}}
									// avatar={<Avatar src={account}></Avatar>}
									label='Agent'
									// onClick={handleClick}
								/>
							</>
						)}

						<Chip
							variant='outlined'
							size='small'
							style={{
								color: 'white',
								backgroundColor: 'rgba(0,0,0,.4)',
								borderRadius: 25,
								fontSize: 14,
								marginLeft: 20,
								marginLeft: 5,
								cursor: 'pointer',
								padding: '15px 7px 15px',
							}}
							avatar={<Avatar src={call}></Avatar>}
							label='CallUs'
							// onClick={handleClick}
						/>
					</Box>
				</Hidden>
			</Box>
			<Login />
		</>
	);
};

export default Header;
